import { render, staticRenderFns } from "./CouponInfo.vue?vue&type=template&id=08a25a6e&scoped=true"
import script from "./CouponInfo.vue?vue&type=script&lang=js"
export * from "./CouponInfo.vue?vue&type=script&lang=js"
import style0 from "./CouponInfo.vue?vue&type=style&index=0&id=08a25a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a25a6e",
  null
  
)

export default component.exports